import LTR from "@brand-icons/ploom/chevron-backward/chevron-backward-ltr.svg";
import RTL from "@brand-icons/ploom/chevron-backward/chevron-backward-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ChevronBackwardIcon = iconFactory("ChevronBackwardIcon", LTR, RTL);
